import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation AddAltMpn($productId: String, $altMpn: String) {
    addAltMpn(productId: $productId, altMpn: $altMpn) {
      id
    }
  }
`

export default function useAddAltMpn() {
  const [mutateFunction] = useMutation(mutation)
  return (productId: string, altMpn: string) =>
    mutateFunction({
      variables: {
        productId,
        altMpn,
      },
    })
}
